export default {"src":"/_next/static/media/check_without_background.89343dfd.svg","height":24,"width":24};